module.exports = __webpack_public_path__ + "img/Group 4063.44ee04ca.png";